angular.module('bmsApp.merrymaids.houseTemplate').controller('MMHouseTemplateSaveCtrl', [
    '$scope', '$state', 'MMHouseTemplateSvc', function (
        $scope
        , $state
        , MMHouseTemplateSvc) {

        function init() {

            if($state.current.name == "main.merrymaids.houseTemplate.index.edit"){
                MMHouseTemplateSvc.read({ id: $state.params.houseTemplateId}).then(
                    function(response) {
                        self.houseTemplate.templateName = response.data.mm_house_template.name;
                        self.houseTemplate.rooms = response.data.mm_house_template.template_rooms;
                        self.houseTemplate.id = response.data.mm_house_template.id;
                    }
                );
                self.pageName = "Edit";
            }else{
                self.pageName = "Create";
            }

            MMHouseTemplateSvc.roomType.options(null).then(function(response){
                self.roomTypes = response.data.options;
            });
        }

        function addRoom(){
            self.houseTemplate.rooms.push({});
        }

        function removeRoom(index){
            self.houseTemplate.rooms.splice(index, 1);
        }

        function submit(){
            MMHouseTemplateSvc.save(self.houseTemplate).then(function(response){
                $state.go('main.merrymaids.houseTemplate.index.view', {
                    houseTemplateId: response.data.mm_house_template_id
                });
            });
        }

        var self = $scope.MMHouseTemplateSaveCtrl = {
            methods: {
                init: init,
                addRoom: addRoom,
                removeRoom: removeRoom,
                submit: submit
            },
            houseTemplate: {
                id: null,
                templateName: '',
                rooms: [{}]
            },
            roomTypes: {},
            pageName: ''
        };
    }]);